// eslint-disable-next-line no-use-before-define
import React from 'react';
import { AR, BR, ES, GB, MX } from 'country-flag-icons/react/3x2';
import { FlagContainer } from './style';
// Bandeiras da lib country-flag-icons (MIT), no formato 3x2.
const FLAGS = { BR, AR, MX, ES, GB };
export const Flag = ({ country, className, }) => {
    const Svg = FLAGS[country];
    return (React.createElement(FlagContainer, { className: ['root-app_flag', className].filter(Boolean).join(' '), "aria-hidden": "true" },
        React.createElement(Svg, null)));
};
//# sourceMappingURL=index.js.map